import { createRouter, createWebHashHistory } from 'vue-router'

// Eager: solo Home (prima pagina) e AuthCallback (OAuth2 callback, timing critico)
import Home from '../views/Home.vue'
import AuthCallback from '../views/AuthCallback.vue'

import zooRoutes from '../modules/zoo/routes.js'
import { aiRoutes } from '../modules/ai/index.js'
import misura21Routes from '../modules/misura21/routes.js'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: AuthCallback,
  },
  {
    path: '/feed',
    name: 'FeedView',
    component: () => import('../views/FeedView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/notifiche',
    name: 'Notifiche',
    component: () => import('../views/NotificationsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/notifiche',
    name: 'NotificationAdminView',
    component: () => import('../views/NotificationAdminView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/celery',
    name: 'CeleryAdminView',
    component: () => import('../views/CeleryAdminView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/rs',
    name: 'RSAdminView',
    component: () => import('../views/RSAdminView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/rs/:id',
    name: 'RsFarmCenterView',
    component: () => import('../modules/rs/views/RsFarmCenterView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/stato',
    name: 'StatoView',
    component: () => import('../views/StatoView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/users',
    name: 'AdminUsersView',
    component: () => import('../views/AdminUsersView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/users/:uid',
    name: 'AdminUserDetail',
    component: () => import('../views/AdminUserDetailView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/orgs',
    name: 'AdminOrgsView',
    component: () => import('../views/AdminOrgsView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/orgs/:id_org',
    name: 'AdminOrgDetail',
    component: () => import('../views/OrgAdminView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/varieties',
    name: 'AdminVarietiesView',
    component: () => import('../views/AdminVarietiesView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  // ==================== PARLA CON PODERI ====================
  {
    path: '/parlacon',
    name: 'ParlaConView',
    component: () => import('../views/ParlaCon.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/parlacon/verifica',
    name: 'ParlaConVerificaQdca',
    component: () => import('../views/ParlaConVerificaQdca.vue'),
    meta: { requiresAuth: true },
  },
  // ==================== MODULO CHAT ====================
  {
    path: '/chat',
    name: 'ChatListView',
    component: () => import('../views/ChatListView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chat/:id',
    name: 'ChatRoomView',
    component: () => import('../views/ChatRoomView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/chat',
    name: 'ChatAdminView',
    component: () => import('../views/ChatAdminView.vue'),
    meta: { requiresAuth: true, requiresRole: 'org_admin' },
  },
  {
    path: '/admin/aepest',
    name: 'AdminAepestView',
    component: () => import('../views/AdminAepestView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/aepest/product/:id_reg',
    name: 'AdminAepestProductView',
    component: () => import('../views/AdminAepestProductView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/aepest/crops',
    name: 'AdminAepestCropDecodeView',
    component: () => import('../views/AdminAepestCropDecodeView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/bdf',
    name: 'AdminBdfView',
    component: () => import('../views/AdminBdfView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/spatial-model',
    name: 'AdminSpatialModelView',
    component: () => import('../views/AdminSpatialModelView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/weather',
    name: 'AdminWeatherView',
    component: () => import('../views/AdminWeatherView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  {
    path: '/admin/weather/:id_station',
    name: 'AdminWeatherDetailView',
    component: () => import('../views/AdminWeatherDetailView.vue'),
    meta: { requiresAuth: true, requiresRole: 'admin' },
  },
  // ==================== PODERI ====================
  {
    path: '/poderi',
    name: 'FarmCenterListView',
    component: () => import('../views/FarmCenterListView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/dashboard',
    name: 'DashboardView',
    component: () => import('../views/DashboardView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id',
    name: 'FarmCenterDetailView',
    component: () => import('../views/FarmCenterDetailView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/season/:seasonId',
    name: 'FarmCenterDetailWithSeason',
    component: () => import('../views/FarmCenterDetailView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:farmCenterId/importa-appezzamenti',
    name: 'AddPlotsView',
    component: () => import('../views/AddPlotsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:farmCenterId/field/:fieldId',
    name: 'FieldDetailView',
    component: () => import('../views/FieldDetailView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:farmCenterId/geo-element/:geoElementId',
    name: 'GeoElementDetailView',
    component: () => import('../views/GeoElementDetailView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:farmCenterId/plot/:plotId/plants',
    name: 'PlantManagerView',
    component: () => import('../views/PlantManagerView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:farmCenterId/plot/:plotId/plants/edit',
    name: 'PlantSurveyEditorView',
    component: () => import('../views/PlantSurveyEditorView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:farmCenterId/plot/:plotId/plants/view',
    name: 'PlantSurveyViewerView',
    component: () => import('../views/PlantSurveyViewerView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/crop-rotation',
    name: 'CropRotationView',
    component: () => import('../views/CropRotationView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/operations',
    name: 'OperationsView',
    component: () => import('../views/OperationsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/oo',
    name: 'OO',
    component: () => import('../views/OperationsView.vue'),
    meta: { requiresAuth: true, defaultTab: 'operazioni' },
  },
  {
    path: '/poderi/:id/oo/operations',
    name: 'OOOperations',
    component: () => import('../views/OperationsView.vue'),
    meta: { requiresAuth: true, defaultTab: 'operazioni' },
  },
  {
    path: '/poderi/:id/oo/observations',
    name: 'OOObservations',
    component: () => import('../views/ObservationView.vue'),
    meta: { requiresAuth: true, defaultTab: 'osservazioni' },
  },
  {
    path: '/poderi/:id/observations',
    name: 'ObservationView',
    component: () => import('../views/ObservationView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/observations/spade-test',
    name: 'SpadeTestView',
    component: () => import('../views/SpadeTestView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/warehouse',
    name: 'WarehouseView',
    component: () => import('../views/WarehouseView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/marketing',
    name: 'MarketingView',
    component: () => import('../views/MarketingView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/dss',
    name: 'DssView',
    component: () => import('../views/DssView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/dss/irrigation',
    name: 'IrrigationView',
    component: () => import('../views/IrrigationView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/dss/nutrition',
    name: 'NutritionView',
    component: () => import('../views/NutritionView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/dss/dashboard',
    name: 'ModelDashboardView',
    component: () => import('@/modules/models/views/ModelDashboardView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/dss/debug',
    name: 'DssModelsView',
    component: () => import('@/modules/models/views/DssModelsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/soils',
    name: 'SoilsView',
    component: () => import('../views/SoilsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/enrichment',
    name: 'PlotEnrichmentView',
    component: () => import('../views/PlotEnrichmentView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:id/team',
    name: 'TeamView',
    component: () => import('../views/TeamView.vue'),
    meta: { requiresAuth: true },
  },
  // ==================== PUBBLICO ====================
  {
    path: '/map/:token',
    name: 'PublicSpatialMapView',
    component: () => import('../views/PublicSpatialMapView.vue'),
    meta: { public: true },
  },
  {
    path: '/azienda/:slug',
    name: 'PublicFarmView',
    component: () => import('../views/PublicFarmView.vue'),
    meta: { public: true },
  },
  {
    path: '/aziende',
    name: 'PublicFarmsListView',
    component: () => import('../views/PublicFarmsListView.vue'),
    meta: { public: true },
  },
  {
    path: '/tree/:code',
    name: 'PublicPlantView',
    component: () => import('../views/PublicPlantView.vue'),
    meta: { public: true },
  },
  {
    path: '/credits',
    name: 'CreditsView',
    component: () => import('../views/CreditsView.vue'),
    meta: { public: true },
  },
  // ==================== MISURA 2.1 ====================
  ...misura21Routes,
  // ==================== DOC ORG ====================
  {
    path: '/docs',
    name: 'DocOrgView',
    component: () => import('../views/DocOrgView.vue'),
    meta: { requiresAuth: true },
  },
  // ==================== ADMIN ====================
  {
    path: '/org-admin',
    name: 'OrgAdmin',
    component: () => import('../views/OrgAdminView.vue'),
    meta: { requiresAuth: true, requiresRole: 'org_admin' },
  },
  {
    path: '/profile',
    name: 'ProfileView',
    component: () => import('../views/ProfileView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin-dbmng',
    name: 'AdminDbmngView',
    component: () => import('../views/AdminDbmngView.vue'),
    meta: { requiresAuth: true, requiresRole: 'org_admin' },
  },
  {
    path: '/admin-dbmng/:casoStudio',
    name: 'AdminDbmngSchemaList',
    component: () => import('../views/AdminDbmngView.vue'),
    meta: { requiresAuth: true, requiresRole: 'org_admin' },
  },
  {
    path: '/admin-dbmng/:casoStudio/:id',
    name: 'AdminDbmngSchemaEdit',
    component: () => import('../views/AdminDbmngView.vue'),
    meta: { requiresAuth: true, requiresRole: 'org_admin' },
  },
  // ==================== ACCESSIONS ====================
  {
    path: '/accessions',
    name: 'AccessionsView',
    component: () => import('../views/AccessionsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/accessions/elab',
    name: 'AccessionElabView',
    component: () => import('../views/AccessionElabView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/accessions/variety/:id_variety',
    name: 'VarietyDetailView',
    component: () => import('../views/VarietyDetailView.vue'),
    meta: { requiresAuth: true },
  },
  // ==================== MODULO AI ====================
  ...aiRoutes,
  // ==================== MODULO Plantrec ====================
  {
    path: '/poderi/:farmCenterId/plantrec',
    name: 'OliverecHomeView',
    component: () => import('../views/OliverecHomeView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/poderi/:farmCenterId/plot/:plotId/plantrec/:schemaId',
    name: 'OliverecSurveyView',
    component: () => import('../views/OliverecSurveyView.vue'),
    meta: { requiresAuth: true },
  },
  // ==================== DEBUG ====================
  // {
  //   path: '/debug/safe-area',
  //   name: 'SafeAreaDebugView',
  //   component: () => import('../views/SafeAreaDebugView.vue'),
  // },
  // ==================== MODULO ZOO ====================
  ...zooRoutes,
  // ==================== INVITO CODICE ====================
  {
    path: '/join/:code',
    name: 'JoinView',
    component: () => import('../views/JoinView.vue'),
  },
  // ==================== FALLBACK ====================
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFoundView.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// Route guard: verifica autenticazione e ruoli
router.beforeEach((to, from, next) => {
  if (to.meta.public || (!to.meta.requiresAuth && !to.meta.requiresRole)) {
    return next()
  }

  let user = null
  try {
    user = JSON.parse(localStorage.getItem('user') || 'null')
  } catch (e) {
    user = null
  }

  if (to.meta.requiresAuth) {
    if (!user || (!user.uid || user.uid === 0)) {
      console.warn(`[Router Guard] Route ${to.path} requires auth, redirecting to /`)
      return next({ path: '/' })
    }
  }

  if (to.meta.requiresRole) {
    const roles = user?.roles || []
    const required = Array.isArray(to.meta.requiresRole) ? to.meta.requiresRole : [to.meta.requiresRole]
    if (!required.some(r => roles.includes(r)) && !roles.includes('admin')) {
      console.warn(`[Router Guard] Route ${to.path} requires role ${to.meta.requiresRole}`)
      return next({ path: '/poderi' })
    }
  }

  next()
})

// vue-i18n genera performance.mark/measure ad ogni t() risolto, senza mai ripulirli
// (buffer "measure" del browser è illimitato): svuotiamo ad ogni navigazione per
// evitare che si accumulino per l'intera sessione app.
router.afterEach(() => {
  if (typeof performance?.clearMarks === 'function') performance.clearMarks()
  if (typeof performance?.clearMeasures === 'function') performance.clearMeasures()
})

// Chunk obsoleto dopo un deploy: forza reload per caricare i nuovi asset
router.onError((err) => {
  const isChunkError = err?.message && (
    err.message.includes('dynamically import') ||
    err.message.includes('Failed to fetch dynamically') ||
    err.message.includes('Importing a module script failed') ||
    err.message.includes('Unable to preload CSS')
  )
  if (!isChunkError) return

  const RELOAD_KEY = 'chunk_reload_at'
  const last = parseInt(sessionStorage.getItem(RELOAD_KEY) || '0', 10)
  const now = Date.now()
  if (now - last < 10_000) {
    console.error('[Router] Chunk error loop rilevato, non ricarico di nuovo', err.message)
    return
  }
  console.warn('[Router] Chunk obsoleto, ricarico la pagina...', err.message)
  sessionStorage.setItem(RELOAD_KEY, String(now))
  window.location.assign(window.location.href)
})

export default router
